import React, { useEffect, useState } from "react"
import Layout from "../../components/Layout";
import * as moment from "moment-timezone";
import api from "../../services/api"
import Swal from "sweetalert2";
import Select from "react-select"

export default function RegionalSends() {
    const [loaded, setLoaded] = useState(false);
    const [totalSent, setTotalSent] = useState("");
    const [searchText, setSearchText] = useState("");
    const [dateBegin, setDateBegin] = useState(moment().startOf("day").format("YYYY-MM-DD"));
    const [dateEnd, setDateEnd] = useState(moment().endOf("day").format("YYYY-MM-DD"));
    const [line, setLine] = useState("");
    const [code, setCode] = useState("");
    const [brand, setBrand] = useState("");
    const [onlyTvs, setOnlyTvs] = useState(false);
    const [regionais, setRegionais] = useState([]);
    const [topProducts, setTopProducts] = useState([]);
    const [topBrands, setTopBrands] = useState([]);
    const [topLines, setTopLines] = useState([]);
    const [topBranches, setTopBranches] = useState([]);

    const lineOptions = [
        { value: "", label: "Selecione a Linha" },
        { value: "Áudio e Vídeo", label: "Áudio e Vídeo" },
        { value: "Brinquedos", label: "Brinquedos" },
        { value: "Climatização", label: "Climatização" },
        { value: "Colchões", label: "Colchões" },
        { value: "Eletro", label: "Eletro" },
        { value: "Estofados", label: "Estofados" },
        { value: "Informática", label: "Informática" },
        { value: "Lazer", label: "Lazer" },
        { value: "Móveis", label: "Móveis" },
        // { value: "N/A", label: "N/A" },
        { value: "Portáteis", label: "Portáteis" },
        { value: "P.S.G.", label: "P.S.G." },
        { value: "Telecom", label: "Telecom" },
        { value: "U.D", label: "U.D" },
        { value: "Util. e Presentes", label: "Util. e Presentes" },
        { value: "Ventilação", label: "Ventilação" },
    ];

    useEffect(() => {
        const load = async () => {
            const startDay = moment.tz("America/Sao_Paulo").startOf("day").toDate().toISOString();
            const endDay = moment.tz("America/Sao_Paulo").endOf("day").toDate().toISOString();
            // const startDay = '2025-07-06'
            // const endDay = '2025-07-06'
            await loadItems(startDay, endDay)
        };
        load();
    }, []);

    const loadItems = async (dateBegin, dateEnd, line, onlyTvs, code, brand) => {
        setLoaded(false);
        try {
            const response = await api.get(`regional-analysis/cards-today`, {
                params: { dateBegin, dateEnd, line, onlyTvs, code, brand }
            });
            console.log(response.data)
            setTotalSent(response.data.totalSent);
            setRegionais(response.data.regionais)
            setTopProducts(response.data.topProducts)
            setTopBrands(response.data.topBrands)
            setTopLines(response.data.topLines)
            setTopBranches(response.data.topBranches)
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
        }
        setLoaded(true);
    };
    const handleSearch = async () => {
        setLoaded(false);
        const start = moment(dateBegin).tz("America/Sao_Paulo").startOf("day").toDate().toISOString();
        const end = moment(dateEnd).tz("America/Sao_Paulo").endOf("day").toDate().toISOString();

        await Promise.all([
            loadItems(start, end, line, onlyTvs, code, brand)
        ])
        setLoaded(true)
    };
    async function getDetails(regional) {
        try {
            const selectedRegional = regionais.find(r => r.regional === regional);

            if (!selectedRegional) {
                Swal.fire("Aviso", "Nenhum produto encontrado para essa regional.", "info");
                return;
            }

            const rows = selectedRegional.products.map(prod => `
            <tr>
                <td style="padding: 8px;">${prod.branch}</td>
                <td style="padding: 8px;">${prod.productCode}</td>
                <td style="padding: 8px;">${prod.productName}</td>
                <td style="padding: 8px;">${prod.productBrand}</td>
                <td style="padding: 8px;">${prod.times}</td>
            </tr> 
                `).join("");

            await Swal.fire({
                title: `Envios`,
                html: `
                    <div style="height: 70vh; width: 100%; overflow-y: auto; overflow-x: auto; text-align:left;">
                        <table style="width:100%; text-align:left; border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th style="position: sticky; top: 0; background: #fff; border-bottom:1px solid #ccc; padding: 8px; z-index: 2;">Filial</th>
                                    <th style="position: sticky; top: 0; background: #fff; border-bottom:1px solid #ccc; padding: 8px; z-index: 2;">Código</th>
                                    <th style="position: sticky; top: 0; background: #fff; border-bottom:1px solid #ccc; padding: 8px; z-index: 2;">Produto</th>
                                    <th style="position: sticky; top: 0; background: #fff; border-bottom:1px solid #ccc; padding: 8px; z-index: 2;">Marca</th>
                                    <th style="position: sticky; top: 0; background: #fff; border-bottom:1px solid #ccc; padding: 8px; z-index: 2;">Qtd. de Envios</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${rows}
                            </tbody>
                        </table>
                    </div>
                `,
                confirmButtonText: "Fechar",
                customClass: {
                    popup: 'swal-left'
                },
                width: "80vw"
            });
        } catch (err) {
            console.error(err);
            setLoaded(true);
            Swal.fire("Erro!", "Problemas ao abrir os dados. Por favor contate o suporte!", "error");
        }
    }
    return (
        <Layout
            menuActive="registers"
            pageTitle="Envios Regional"
            enableSearchBar={false}
            searchTerm={""}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={"handleSearchBar"}
        >
            <div className="container mt-2">
                <form className="row g-3 align-items-end">
                    <div className="col-md-2">
                        <label htmlFor="dtBegin-filter" className="form-label">
                            Data Inicial
                        </label>
                        <input
                            className="form-control"
                            type="date"
                            id="dtBegin-filter"
                            value={dateBegin}
                            onChange={(e) => setDateBegin(e.target.value)}
                        />
                    </div>

                    <div className="col-md-2">
                        <label htmlFor="dtEnd-filter" className="form-label">
                            Data Final
                        </label>
                        <input
                            className="form-control"
                            type="date"
                            id="dtEnd-filter"
                            value={dateEnd}
                            onChange={(e) => setDateEnd(e.target.value)}
                        />
                    </div>

                    <div className="col-md-2">
                        <label htmlFor="line-filter" className="form-label">
                            Linha
                        </label>
                        <Select
                            id="line-filter"
                            options={lineOptions}
                            value={lineOptions.find((opt) => opt.value === line)}
                            onChange={(selected) => setLine(selected ? selected.value : "")}
                            placeholder="Escolha uma linha"
                        />
                    </div>

                    <div className="col-md-2">
                        <label htmlFor="code-filter" className="form-label">
                            Código
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            id="code-filter"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="Ex: 30155"
                        />
                    </div>

                    <div className="col-md-2">
                        <label htmlFor="brand-filter" className="form-label">
                            Marca
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            id="brand-filter"
                            value={brand}
                            onChange={(e) => setBrand(e.target.value)}
                            placeholder="Ex: Samsung"
                        />
                    </div>

                    <div className="col-md-2 d-flex align-items-center" style={{ "marginTop": 30 }}>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="onlyTvs-filter"
                                checked={onlyTvs}
                                onChange={(e) => setOnlyTvs(e.target.checked)}
                                style={{ transform: "scale(1.8)" }}
                            />
                            <label className="form-check-label" htmlFor="onlyTvs-filter">
                                &nbsp;&nbsp; Apenas TVs
                            </label>
                        </div>
                    </div>

                    <div className="col-md-12 d-flex gap-2">
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={handleSearch}
                        >
                            Buscar
                        </button>
                        &nbsp;&nbsp;
                        <button
                            className="btn btn-warning"
                            type="button"
                            onClick={() => window.location.reload()}
                        >
                            Limpar
                        </button>
                    </div>
                </form>
            </div>
            <br></br>
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <h3>Total de Envios - {totalSent}</h3>
                            </div>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row" style={{marginTop:"10px"}}>
                                <div className="col-xs-4">
                                    <h4>Envios Regional</h4>
                                    <div style={{ maxHeight: "820px", overflow: "auto" }}>
                                        <table className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Regional</th>
                                                    <th>Envios</th>
                                                    <th>Opções</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {regionais.map(
                                                    (data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {
                                                                        data.regional
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        data.amount
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <button className="btn btn-primary btn-large"
                                                                        type="button" onClick={(e) => {
                                                                            getDetails(data.regional)
                                                                        }}>
                                                                        Detalhes
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="col-xs-4">
                                    <h4>Top 100 Produtos</h4>
                                    <div style={{ maxHeight: "820px", overflow: "auto" }}>
                                        <table
                                            className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Codigo</th>
                                                    <th>Nome</th>
                                                    <th>Envios</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {topProducts.map(
                                                    (data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {
                                                                        data.code
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        data.name
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        data.times
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="col-xs-4">
                                    <h4>Top Marcas</h4>
                                    <div style={{ maxHeight: "820px", overflow: "auto" }}>
                                        <table className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Envios</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {topBrands.map(
                                                    (data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {
                                                                        data.brand
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        data.times
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{marginTop:"10px"}}>
                                <div className="col-xs-4">
                                    <h4>Top Filiais</h4>
                                    <div style={{ maxHeight: "820px", overflow: "auto" }}>
                                        <table className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Envios</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {topBranches.map(
                                                    (data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {
                                                                        data.branch
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        data.times
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-xs-4">
                                    <h4>Top Linhas</h4>
                                    <div style={{ maxHeight: "820px", overflow: "auto" }}>
                                        <table className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Envios</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {topLines.map(
                                                    (data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {
                                                                        data.line
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        data.times
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
} 